export default __webpack_public_path__ + "static/media/google-icon.15e5ae18.svg";